<div class="row">
    <div class="col-md-7">
        <h2>Manage Orders</h2>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <mt-search-bar (searched)="search($event)"></mt-search-bar>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="pull-left dropdown-container">
            <mt-search-filter-select [items]="statuses" entity="Status" (selectionChanged)="getOrders()"> </mt-search-filter-select>
        </div>
        <div class="pull-left dropdown-container">
            <mt-search-filter-select *ngIf="!userIsCustomer" [items]="customers" entity="Customer" (selectionChanged)="getOrders()"> </mt-search-filter-select>
        </div>
        <div *ngIf="!userIsCarrierOrCustomer()" class="pull-left checkbox-filter">
            <label style="margin: 5px">
                <input
                    [(ngModel)]="showArchived"
                    type="checkbox"
                    (change)="getOrders()"
                />
                Include Archived
            </label>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <form *ngIf="scheduledOrderFilterForm" [formGroup]="scheduledOrderFilterForm">
            <div class="col-md-2 date-selector-container">
                <mt-dynamic-field
                    [field]="abstractSearchUserControls.ScheduledStartDate"
                    (valueChanges)="ScheduledStartDateChange($event)"
                    [form]="scheduledOrderFilterForm"
                ></mt-dynamic-field>
            </div>
            <div class="col-md-2 date-selector-container">
                <mt-dynamic-field
                    [field]="abstractSearchUserControls.ScheduledEndDate"
                    (valueChanges)="ScheduledEndDateChange($event)"
                    [form]="scheduledOrderFilterForm"
                ></mt-dynamic-field>
            </div>
        </form>
        <div class="col-md-2">
            <button [ngStyle]="{ 'margin-top': '23px' }" class="btn btn-default" (click)="clearDateFilters()">Clear Date Filters</button>
        </div>
    </div>
</div>
<br />
<mt-entity-list
    *ngIf="scheduledOrderFilterForm"
    [entities]="orders"
    [total]="total"
    [(itemsPerPage)]="itemsPerPage"
    [(currentPage)]="currentPage"
    (pageChanged)="getOrders()"
    (itemSelectedEvent)="orderSelected($event)"
    (columnSelectedEvent)="columnSelected($event)"
    (columnSortedEvent)="columnSorted($event)"
    [entityListConfig]="entityListConfig"
>
</mt-entity-list>
